export enum EChoirStatus {
    FORMING = 1,
    OPERATING = 2,
    SUSPENDED = 3,
    DISBANDED = 4,
}

export enum EChoirConcertFrequency {
    WEEKLY = 1,
    MONTHLY = 2,
    EVERY_TWO_MONTHS = 3,
    EVERY_THREE_MONTHS = 4,
    EVERY_HALF_A_YEAR = 5,
    ANNUALLY = 6,
}

// finanszírozási forma
export enum EChoirFundingModel {
    MEMBERSHIP_FEE = 1,
    DONATION_ASSOCIATION_SPONSORED = 2, 
    PAYMENT = 3,
}

// Méret
export enum EChoirSize {
    SMALL_ENSEMBLE = 1,
    ENSEMBLE = 2,
    SMALL_CHAMBER_CHOIR = 3,
    CHAMBER_CHOIR = 4,
    CHOIR = 5,
};

export enum EChoirType {
    MENS = 1,
    WOMENS = 2,
    MIXED = 3,
}

export enum EAgeRange {
    A7 = 7,
    A14 = 14,
    A20 = 20,
    A30 = 30,
    A40 = 40,
    A50 = 50,
    A60 = 60,
    AInf = 100,
}

export enum EProficiencyLevel {
    NONE = 1,
    BASIC = 2,
    INTERMEDIATE = 3,
    INTERMEDIATE_ADVANCED = 4,
    ADVANCED = 5,
}

export enum EConcertConditions {
    QUIET_AUDIENCE = 1,
    NOISY_AUDIENCE = 2,
    INDOOR = 3,
    OUTDOOR = 4,
    LOCAL_CONCERTS = 5,
    FREQUENT_TRAVEL = 6,
}

export enum ERehearsalType {
    REHEARSAL = 1,
    SECTIONAL = 2,
    TUTORING = 3,
}

export interface IRehearsal {
    day: number;
    time: [number, number];
    type: ERehearsalType;
}

export interface IChoirMetaDetails {
    status?: EChoirStatus;
    startDate?: Date;
    repertoirSample?: string;
    choirCamps?: boolean;
    choirWeekEnds?: boolean;
    rehearsals: IRehearsal[];
    sectionals?: boolean;
    rehearsalPreview?: boolean;
    concertFrequency?: EChoirConcertFrequency;
    fundingModel?: EChoirFundingModel[];
    choirSize?: EChoirSize;
    choirType?: EChoirType;
    proficiencyLevel?: EProficiencyLevel;
    ageRange?: EAgeRange[];
    uniform?: boolean;
    concertConditions?: EConcertConditions[];
}
